import { Suspense } from 'react';

import { GLTFLoader } from 'app/modules/wallforming/components/scenes/objects/helpers/GLTFLoader';
import { RepresentationLoader } from 'app/modules/wallforming/components/scenes/objects/helpers/RepresentationLoader';
import { PreviewPart } from 'app/modules/wallforming/components/scenes/objects/placement-preview/PreviewPart';

import type { PartPlacement } from 'api/models';

interface PreviewLoaderProps {
    articleId: string;
    articleNumber: string;
    part: PartPlacement;
    useDefaultMaterial: boolean;
    onLoaded?: () => void;
}

export const PreviewLoader = ({ articleId, articleNumber, part, onLoaded, useDefaultMaterial }: PreviewLoaderProps) => (
    <Suspense>
        <RepresentationLoader articleId={articleId} articleNumber={articleNumber} isInteractive={false}>
            {({ articleRepresentation, gltfAssets }) => (
                <GLTFLoader
                    articleId={articleId}
                    articleRepresentation={articleRepresentation}
                    gltfAssets={gltfAssets.filter((asset) => asset.partName === part.name)}
                    isMainCanvas={false}
                >
                    {({ articleMeshes }) => (
                        <PreviewPart
                            articleMeshes={articleMeshes}
                            part={part}
                            useDefaultMaterial={useDefaultMaterial}
                            onLoaded={onLoaded}
                        />
                    )}
                </GLTFLoader>
            )}
        </RepresentationLoader>
    </Suspense>
);
